if (!customElements.get('safi-configurator')) {
  class SafiConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.modal = this.querySelector('[data-configurator-modal]');
      this.total = this.querySelector('[data-config-total]');
      this.message = this.querySelector('[data-config-message]');
      this.addButton = this.querySelector('[data-config-add]');
      this.basePrice = Number(this.dataset.basePriceCents || 0);

      this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
        button.addEventListener('click', () => this.selectGalleryImage(button));
      });

      this.querySelectorAll('[data-delivery-option]').forEach((button) => {
        button.addEventListener('click', () => this.selectDelivery(button.dataset.deliveryOption));
      });

      this.querySelectorAll('[data-config-option-toggle]').forEach((button) => {
        button.addEventListener('click', () => this.toggleOption(button.closest('[data-config-option]')));
      });

      this.querySelector('[data-configurator-open]')?.addEventListener('click', () => this.openModal());
      this.querySelectorAll('[data-configurator-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeModal());
      });

      this.modal?.addEventListener('click', (event) => {
        if (event.target === this.modal) this.closeModal();
      });
      this.modal?.addEventListener('close', () => this.unlockPage());
      this.addButton?.addEventListener('click', () => this.addSelectionToCart());

      this.updateTotal();
    }

    selectGalleryImage(button) {
      const image = this.querySelector('.safi-configurator__main-image');
      if (!image || !button.dataset.imageSrc) return;

      image.src = button.dataset.imageSrc;
      image.removeAttribute('srcset');
      image.alt = button.dataset.imageAlt || '';
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb === button);
      });
    }

    selectDelivery(value) {
      this.querySelectorAll('[data-delivery-option]').forEach((button) => {
        const selected = button.dataset.deliveryOption === value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      this.querySelectorAll('[data-delivery-label], [data-modal-delivery-label]').forEach((label) => {
        label.textContent = value;
      });
    }

    toggleOption(option) {
      if (!option) return;

      const selected = !option.classList.contains('is-selected');
      const input = option.querySelector('[data-config-option-input]');
      const button = option.querySelector('[data-config-option-toggle]');
      option.classList.toggle('is-selected', selected);
      if (input) input.checked = selected;
      button?.setAttribute('aria-pressed', String(selected));
      this.updateTotal();
    }

    updateTotal() {
      const optionsPrice = Array.from(this.querySelectorAll('[data-config-option].is-selected'))
        .reduce((sum, option) => sum + Number(option.dataset.priceCents || 0), 0);

      if (this.total) this.total.textContent = this.formatMoney(this.basePrice + optionsPrice);
    }

    formatMoney(cents) {
      const currency = window.Shopify?.currency?.active || 'EUR';
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    }

    openModal() {
      if (!this.modal) return;
      if (typeof this.modal.showModal === 'function') this.modal.showModal();
      else this.modal.setAttribute('open', '');
      document.documentElement.classList.add('safi-configurator-open');
    }

    closeModal() {
      if (!this.modal) return;
      if (typeof this.modal.close === 'function' && this.modal.open) this.modal.close();
      else this.modal.removeAttribute('open');
      this.unlockPage();
    }

    unlockPage() {
      document.documentElement.classList.remove('safi-configurator-open');
    }

    async addSelectionToCart() {
      const baseVariantId = this.dataset.baseVariantId;
      if (!baseVariantId || !this.addButton) return;

      const items = [{
        id: Number(baseVariantId),
        quantity: 1,
        properties: { Levering: this.querySelector('[data-delivery-label]')?.textContent || 'In doos' }
      }];

      this.querySelectorAll('[data-config-option].is-selected').forEach((option) => {
        if (!option.dataset.variantId) return;
        items.push({ id: Number(option.dataset.variantId), quantity: 1 });
      });

      const label = this.addButton.querySelector('[data-config-add-label]');
      this.addButton.disabled = true;
      this.addButton.classList.add('is-loading');
      if (label) label.textContent = 'Toevoegen...';
      if (this.message) this.message.textContent = '';

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error('Producten konden niet worden toegevoegd.');
        window.location.href = window.routes?.cart_url || '/cart';
      } catch (error) {
        this.addButton.disabled = false;
        this.addButton.classList.remove('is-loading');
        if (label) label.textContent = 'In mijn winkelwagen';
        if (this.message) this.message.textContent = error.message;
      }
    }
  }

  customElements.define('safi-configurator', SafiConfigurator);
}
